/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AutoCommDetailsApi } from '../api/autocommdetails.api';
import { switchMap, map } from 'rxjs/operators';
import { AutoCommDetailsData, AutoCommDetails } from '../../../interfaces/masters/autocommdetails';

@Injectable()
export class AutoCommDetailsService extends AutoCommDetailsData {

  constructor(private api: AutoCommDetailsApi) {
    super();
  }


  list(url: string): Observable<AutoCommDetails[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<AutoCommDetails>{
      return this.api.getById(url);
  }

  create(url: string, data:AutoCommDetails): Observable<AutoCommDetails> {
    return this.api.add(url,data);
  }

  update(url: string, data:AutoCommDetails): Observable<AutoCommDetails> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
